/**
 * The 29 theme palette keys map 1:1 to the CSS variables defined in
 * src/index.scss (each key is the variable name without the leading `--`).
 * Keep this list in sync with that file and the admin generator.
 */
export const PALETTE_KEYS = [
  "background",
  "background-muted",
  "on-background",
  "on-background-muted",
  "primary",
  "primary-highlight",
  "primary-muted",
  "on-primary",
  "on-primary-muted",
  "secondary",
  "secondary-highlight",
  "secondary-muted",
  "on-secondary",
  "on-secondary-muted",
  "error",
  "error-highlight",
  "error-muted",
  "on-error",
  "on-error-muted",
  "success",
  "success-highlight",
  "success-muted",
  "on-success",
  "on-success-muted",
  "warning",
  "warning-highlight",
  "warning-muted",
  "on-warning",
  "on-warning-muted",
] as const;

const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

/**
 * Applies a site's theme palette by overriding the matching CSS variables on
 * the document root. Unknown keys and non-hex values are ignored so a bad
 * config can never break rendering — the static defaults in index.scss remain
 * the fallback for any key not provided.
 */
export function applyColorScheme(palette: Record<string, string> | undefined | null): void {
  if (!palette || typeof palette !== "object") return;
  const root = document.documentElement;
  for (const key of PALETTE_KEYS) {
    const value = palette[key];
    if (typeof value === "string" && HEX_COLOR.test(value)) {
      root.style.setProperty(`--${key}`, value);
    }
  }
}
